import { createStyles, makeStyles, Theme } from '@material-ui/core';


const useStyles = makeStyles(({ breakpoints }: Theme) => createStyles({
  icon: {
    color: '#263245',
    fontSize: 20,
    verticalAlign: 'middle',
  },
  mainPlayIcon: {
    fontSize: 50,
    verticalAlign: 'middle',
    color: '#FFF',
    [breakpoints.down('xs')]: {
      fontSize: 18,
    },
  },
  mainPlayButton: {
    height: 100,
    width: 100,
    background: 'rgba(28, 38, 71, 0.75) !important',
    zIndex: 1000,
    transition: 'background-color 0.3s ease !important',

    '&:hover': {
      background: 'rgba(28, 38, 71, 0.6) !important',
      transition: 'background-color 0.3s ease',
    },
    [breakpoints.down('xs')]: {
      height: 40,
      width: 40,
    },
    '& *': {
      opacity: '1 !important',
    },
  },
  mainPauseButton: {
    opacity: 0,
  },
  controlPanel: {
    background: '#FFF',
    position: 'relative',
    top: -6,
    boxShadow: '0 -4px 4px 0 rgba(0,0,0,0.25)',
  },
  mobileMainPlayButton: {
    background: 'rgba(28,38,71,0.75) !important',

    '& .MuiIconButton-label': {
      paddingLeft: '15%',
    },
  },
  buttonWrapper: {
    height: '100vh',
    maxHeight: 'calc(100% - 30px)',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mobileButtonWrapper: {
    maxHeight: '100%',
  },
}), { name: 'PlayerControls' });

export default useStyles;
